import type { FlowRunDetailResponse } from "@ando/core";
import * as React from "react";

import type { SurfaceModel } from "./surface";

type CustomModel = Extract<SurfaceModel, { kind: "custom" }>;

export interface CustomSurfaceProps {
  readonly run?: FlowRunDetailResponse;
  readonly surface: CustomModel;
  readonly flowId: string;
  readonly flowName?: string;
  readonly focusRunId?: string;
  readonly onCleared?: () => void;
  readonly onSelectRun?: (runId: string) => void;
}

type Registration = {
  readonly version: number;
  readonly component: React.LazyExoticComponent<React.ComponentType<CustomSurfaceProps>>;
};

const REGISTRY: Readonly<Record<string, Registration>> = {
  "email-support-monitor": {
    version: 1,
    component: React.lazy(() => import("./EmailSupportCustomSurface")),
  },
  "cad-to-quote": { version: 2, component: React.lazy(() => import("./CadToQuoteSurface")) },
  "continuous-reconciliation": {
    version: 2,
    component: React.lazy(() => import("./ContinuousReconciliationSurface")),
  },
};

export function supportsCustomSurface(surface: CustomModel): boolean {
  return REGISTRY[surface.key]?.version === surface.version;
}

export function CustomSurface(props: CustomSurfaceProps): React.JSX.Element | null {
  const registration = REGISTRY[props.surface.key];
  if (!registration || registration.version !== props.surface.version) return null;
  const Component = registration.component;
  return (
    <React.Suspense
      fallback={<div className="p-6 text-ink-3 text-sm">Caricamento interfaccia…</div>}
    >
      <Component {...props} />
    </React.Suspense>
  );
}
